import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { Dashboard } from './pages/Dashboard';
import { CommissionPayments } from './pages/CommissionPayments';
import { MerchantOnboarding } from './pages/MerchantOnboarding';
import { OfferManagement } from './pages/OfferManagement';
import { Transactions } from './pages/Transactions';
import { Settings } from './pages/Settings';
function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        {/* Public/Standalone Routes */}
        <Route path="/onboarding" element={<MerchantOnboarding data-id="element-3" />} data-id="element-2" />

        {/* Protected Dashboard Routes */}
        <Route path="/" element={<DashboardLayout data-id="element-5">
              <Dashboard data-id="element-6" />
            </DashboardLayout>} data-id="element-4" />

        <Route path="/transactions" element={<DashboardLayout data-id="element-8">
              <Transactions data-id="element-9" />
            </DashboardLayout>} data-id="element-7" />

        <Route path="/offers" element={<DashboardLayout data-id="element-11">
              <OfferManagement data-id="element-12" />
            </DashboardLayout>} data-id="element-10" />

        <Route path="/payments" element={<DashboardLayout data-id="element-14">
              <CommissionPayments data-id="element-15" />
            </DashboardLayout>} data-id="element-13" />

        <Route path="/settings" element={<DashboardLayout data-id="element-17">
              <Settings data-id="element-18" />
            </DashboardLayout>} data-id="element-16" />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-20" />} data-id="element-19" />
      </Routes>
    </Router>;
}
export { App };